import { precallMemoryConstants } from "@data/constants/precallMemoryConstants"

/**
 * Ce que cet appareil se souvient d'avoir vérifié.
 *
 * Tranche à part, et non un champ de `liveMode`, pour une raison de fond :
 * `liveMode` décrit UNE séance et se vide à chaque entrée et sortie, alors que
 * ce souvenir décrit UN poste de travail et doit traverser les séances — c'est
 * toute son utilité. Logé dans `liveMode`, il aurait fallu l'exclure à la main
 * de chaque remise à zéro, et le premier oubli l'aurait silencieusement rendu
 * inopérant.
 *
 * Il n'est délibérément PAS effacé à la déconnexion, contrairement à
 * `precallDevices` : il ne décrit personne, seulement le matériel branché sur
 * la machine. Sur un portable familial, l'élève suivant a le même micro et la
 * même caméra que le précédent — lui refaire le parcours ne protégerait de
 * rien.
 */
const initialState = {
    /** `{ signature, components?, at }` du dernier parcours mené à son terme, tout au vert. */
    verified: null,
}

export default function precallMemory(state = initialState, action) {
    switch (action.type) {
        case precallMemoryConstants.REMEMBER_DEVICE_CHECK:
            if (!action.signature) return state
            return {
                ...state,
                verified: { signature: action.signature, components: action.components, at: Date.now() },
            }
        /*
         * Oublier après un signalement technicien.
         *
         * L'élève qui est entré la dernière fois avec un micro en panne a
         * précisément le matériel qu'on ne peut pas dire vérifié. L'empreinte,
         * elle, n'a pas bougé — rien dans la configuration ne trahit un casque
         * mort. C'est le seul cas où l'on sait mieux qu'elle.
         */
        case precallMemoryConstants.FORGET_DEVICE_CHECK:
            return { ...state, verified: null }
        default:
            return state
    }
}
